export default __webpack_public_path__ + "static/media/logo-small.bcef668f.svg";